import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.2 6.96v8.612c0 .98.385 1.918 1.076 2.61l10.14 10.138a3.686 3.686 0 0 0 5.213 0l7.69-7.69a3.686 3.686 0 0 0 0-5.214L18.18 5.277A3.7 3.7 0 0 0 15.57 4.2H6.965A2.757 2.757 0 0 0 4.2 6.96m6.451 5.53a1.84 1.84 0 0 1-1.843-1.844c0-1.02.824-1.843 1.843-1.843s1.844.824 1.844 1.843-.824 1.844-1.844 1.844"
    }, null, -1)
  ]))]))
}
export default { render: render }